var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M22.441,29.8a12.228,12.228,0,0,0,2.372,7.245l-1.555,4.588,4.784-1.52a12.335,12.335,0,1,0-5.6-10.312",
    transform: "translate(-22.441 -17.445)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.09,
    y1: 1.092,
    x2: -0.086,
    y2: 1.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ac14b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06853a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_64",
    x: 0,
    y: 0,
    width: 46.744,
    height: 46.744,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(-3579 -1967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(3589.843 1975.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 24.904,
    height: 24.712,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3579, 1967)",
    filter: "url(#Path_64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64-2",
    "data-name": "Path 64",
    d: "M28.745,14A14.134,14.134,0,0,1,7.814,26.261L0,28.744l2.547-7.512A13.854,13.854,0,0,1,.523,14a14.111,14.111,0,0,1,28.221,0M14.635,2.23A11.83,11.83,0,0,0,2.771,14a11.65,11.65,0,0,0,2.26,6.9L3.549,25.276l4.558-1.448A11.876,11.876,0,0,0,26.5,14,11.831,11.831,0,0,0,14.635,2.23m7.125,15c-.087-.143-.318-.229-.663-.4s-2.048-1-2.364-1.116-.549-.172-.778.171-.894,1.117-1.1,1.346-.4.257-.748.086a9.461,9.461,0,0,1-2.782-1.7A10.434,10.434,0,0,1,11.4,13.233c-.2-.343-.02-.529.151-.7.156-.155.347-.4.52-.6a2.361,2.361,0,0,0,.346-.574.623.623,0,0,0-.03-.6c-.086-.171-.778-1.86-1.067-2.548s-.575-.66-.778-.66a4.977,4.977,0,0,0-.575.06,1.953,1.953,0,0,0-1.01.429A3.836,3.836,0,0,0,7.751,10.9,6.642,6.642,0,0,0,9.163,14.45c.173.23,2.392,3.808,5.909,5.182s3.517.915,4.151.857a3.491,3.491,0,0,0,2.335-1.631,2.852,2.852,0,0,0,.2-1.631",
    transform: "translate(9 6)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 28.744,
    height: 28.744,
    transform: "translate(3588 1973)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.9282fe4f156a32b24b3ffdf40031971b.svg";
export { ForwardRef as ReactComponent };